var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClickTab },
          model: {
            value: _vm.tabsName,
            callback: function ($$v) {
              _vm.tabsName = $$v
            },
            expression: "tabsName",
          },
        },
        _vm._l(_vm.tabsConfig, function (tab) {
          return _c(
            "el-tab-pane",
            { key: tab.name, attrs: { label: tab.label, name: tab.name } },
            [
              tab.tips
                ? _c("el-alert", {
                    staticStyle: { color: "#333" },
                    attrs: {
                      title: tab.tips,
                      type: "info",
                      "show-icon": "",
                      closable: false,
                    },
                  })
                : _vm._e(),
            ],
            1
          )
        }),
        1
      ),
      _vm.tabsName === "1"
        ? [
            _c(
              "el-table",
              {
                staticClass: "table-wrap",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.list,
                  border: "",
                  "header-cell-style": _vm.headerCellStyle,
                  "row-style": _vm.rowStyle,
                },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "cate_name", label: "二级分类" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            ["合计", "总计"].includes(scope.row.cate_name)
                              ? _c("span", [
                                  _vm._v(_vm._s(scope.row.cate_name)),
                                ])
                              : _c(
                                  "span",
                                  {
                                    staticClass: "clickable",
                                    on: {
                                      click: function ($event) {
                                        return _vm.onClickCateName(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(scope.row.cate_name))]
                                ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    36757338
                  ),
                }),
                _c(
                  "el-table-column",
                  { attrs: { prop: "sku_num" } },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("SKU数量")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content:
                                  "去重统计该分类下客户购买的商品规格种类",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  { attrs: { prop: "goods_num" } },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("商品数量")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content:
                                  "该分类下客户购买的商品总数量（同一商品多次购买累加）",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  { attrs: { prop: "amount" } },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("消费点数")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content:
                                  "订单消费点数 = 卡消费点数 - 退回卡点数",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  {
                    attrs: { prop: "consume_rate" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                " " + _vm._s(row.consume_rate + "%") + " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1790288032
                    ),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("消费占比")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "当前消费点数 / 总计消费点数 * 100%",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  { attrs: { prop: "cost_a0" } },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("成本")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "卡实际分摊真实成本价A0",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  {
                    attrs: { prop: "cost_rate" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(" " + _vm._s(row.cost_rate + "%") + " "),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3296176327
                    ),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("成本率")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "成本 / 卡实际分摊抵扣金额 * 100%",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination__style" },
              [
                _c("el-pagination", {
                  attrs: {
                    background: "",
                    layout: "total, sizes, prev, pager, next, jumper",
                    "page-sizes": [20, 50, 100, 300, 500, 1000],
                    "page-size": _vm.pages.pagesize,
                    "current-page": _vm.pages.page,
                    total: _vm.pages.totalCount,
                  },
                  on: {
                    "current-change": _vm.handlePageChange,
                    "size-change": _vm.handleSizeChange,
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
      _vm.tabsName === "2"
        ? [
            _c(
              "el-form",
              {
                staticStyle: { "margin-top": "10px", "margin-bottom": "-10px" },
                attrs: { "label-width": "90px", inline: "", size: "mini" },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "商品二级分类", prop: "cate_name" } },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: "请输入二级分类名称",
                        clearable: "",
                      },
                      model: {
                        value: _vm.cate_name,
                        callback: function ($$v) {
                          _vm.cate_name = $$v
                        },
                        expression: "cate_name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary", size: "mini" },
                        on: { click: _vm.onClickSearch },
                      },
                      [_vm._v("搜索")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm.searchedWithCateName
              ? _c("el-alert", {
                  attrs: {
                    title: "当前已应用筛选，合计及占比基于筛选结果计算。",
                    type: "warning",
                    closable: false,
                  },
                })
              : _vm._e(),
            _c(
              "el-table",
              {
                staticClass: "table-wrap",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.list,
                  border: "",
                  "header-cell-style": _vm.headerCellStyle,
                  "row-style": _vm.rowStyle,
                },
              },
              [
                _c("el-table-column", {
                  attrs: { prop: "second_name", label: "二级分类" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(" " + _vm._s(scope.row.second_name) + " "),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    527650837
                  ),
                }),
                _c("el-table-column", {
                  attrs: { prop: "cate_name", label: "三级分类" },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(" " + _vm._s(scope.row.cate_name) + " "),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    4031942614
                  ),
                }),
                _c(
                  "el-table-column",
                  { attrs: { prop: "sku_num" } },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("SKU数量")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content:
                                  "去重统计该分类下客户购买的商品规格种类",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  { attrs: { prop: "goods_num" } },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("商品数量")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content:
                                  "该分类下客户购买的商品总数量（同一商品多次购买累加）",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  { attrs: { prop: "amount" } },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("消费点数")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content:
                                  "订单消费点数 = 卡消费点数 - 退回卡点数",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  {
                    attrs: { prop: "consume_rate" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(
                                " " + _vm._s(row.consume_rate + "%") + " "
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1790288032
                    ),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("消费占比")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "当前消费点数 / 总计消费点数 * 100%",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  { attrs: { prop: "cost_a0" } },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("成本")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "卡实际分摊真实成本价A0",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
                _c(
                  "el-table-column",
                  {
                    attrs: { prop: "cost_rate" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var row = ref.row
                            return [
                              _vm._v(" " + _vm._s(row.cost_rate + "%") + " "),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3296176327
                    ),
                  },
                  [
                    _c("template", { slot: "header" }, [
                      _c(
                        "span",
                        { staticClass: "header-field-container" },
                        [
                          _c("span", [_vm._v("成本率")]),
                          _c(
                            "el-tooltip",
                            {
                              attrs: {
                                content: "成本 / 卡实际分摊抵扣金额 * 100%",
                                placement: "top",
                                "popper-class": "large-tooltip",
                              },
                            },
                            [
                              _c("i", {
                                staticClass:
                                  "el-icon-warning-outline header-info-icon",
                              }),
                            ]
                          ),
                        ],
                        1
                      ),
                    ]),
                  ],
                  2
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination__style" },
              [
                _c("el-pagination", {
                  attrs: {
                    background: "",
                    layout: "total, sizes, prev, pager, next, jumper",
                    "page-sizes": [20, 50, 100, 300, 500, 1000],
                    "page-size": _vm.pages.pagesize,
                    "current-page": _vm.pages.page,
                    total: _vm.pages.totalCount,
                  },
                  on: {
                    "current-change": _vm.handlePageChange,
                    "size-change": _vm.handleSizeChange,
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
      _c(
        "keep-alive",
        [
          _vm.tabsName === "4"
            ? _c("provinceDetailStatistics", {
                ref: "provinceDetailStatistics",
                staticStyle: { "margin-top": "10px" },
                attrs: {
                  entry: _vm.entry,
                  "order-id":
                    (_vm.originParams && _vm.originParams.order_id) || "",
                  "category-id":
                    (_vm.originParams && _vm.originParams.category_id) || "",
                  "order-type":
                    (_vm.originParams && _vm.originParams.type) || "",
                },
                on: { "jump-city": _vm.onJumpCityStatistics },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "keep-alive",
        [
          _vm.tabsName === "3"
            ? _c("cityDetailStatistics", {
                ref: "cityDetailStatistics",
                staticStyle: { "margin-top": "10px" },
                attrs: {
                  entry: _vm.entry,
                  "order-id":
                    (_vm.originParams && _vm.originParams.order_id) || "",
                  "category-id":
                    (_vm.originParams && _vm.originParams.category_id) || "",
                  "order-type":
                    (_vm.originParams && _vm.originParams.type) || "",
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }